/* unplugin-vue-components disabled */import { render } from "./prize_detail.vue?vue&type=template&id=d241c6c2&scoped=true"
import script from "./prize_detail.vue?vue&type=script&lang=js"
export * from "./prize_detail.vue?vue&type=script&lang=js"

import "./prize_detail.vue?vue&type=style&index=0&id=d241c6c2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d241c6c2"]])

export default __exports__